import React, { useId } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography
} from '@mui/material'
import DualActionButtons from '../../../components/action_button/DualActionButtons'
import TemporaryAccessCodeBox from './TemporaryAccessCodeBox'
import { UI_COLOR_PRIMARY, UI_COLOR_PRIMARY_HOVER } from '../../../constants/uiColors'
import {
  getTemporaryAccessContent,
  TEMPORARY_ACCESS_TEXT
} from '../../constants/temporaryAccessConstants'
import TemporaryAccessParagraphs from './TemporaryAccessParagraphs'
import '../../../css/temporary_access.scss'

const TemporaryAccessModal = ({
  access,
  onClose,
  title = TEMPORARY_ACCESS_TEXT.createdTitle,
  variant = 'create'
}) => {
  const titleId = useId()
  const { paragraphs, footer } = getTemporaryAccessContent(variant)

  return (
    <Dialog
      open
      onClose={(_event, reason) => {
        if (reason === 'backdropClick') return
        onClose()
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth={false}
      aria-labelledby={titleId}
      PaperProps={{ className: 'temporary-access-paper temporary-access-modal' }}
    >
      <DialogTitle id={titleId} className="temporary-access-title">
        {title}
      </DialogTitle>
      <Divider className="temporary-access-divider" />
      <DialogContent className="temporary-access-content">
        <TemporaryAccessParagraphs paragraphs={paragraphs} />
        <TemporaryAccessCodeBox
          email={access.email}
          temporaryPassword={access.temporary_password}
          expiresAt={access.expiresAt}
        />
        {footer ? <Typography className="temporary-access-footer">{footer}</Typography> : null}
      </DialogContent>
      <DialogActions className="temporary-access-actions">
        <DualActionButtons
          fullWidthOnMobile={false}
          minWidth={112}
          secondaryAction={{ visible: false }}
          primaryAction={{
            label: TEMPORARY_ACCESS_TEXT.close,
            icon: null,
            color: UI_COLOR_PRIMARY,
            hoverColor: UI_COLOR_PRIMARY_HOVER,
            onClick: onClose
          }}
        />
      </DialogActions>
    </Dialog>
  )
}
export default TemporaryAccessModal
